<template>
  <v-app>
    <main-header v-if="isAuthenticated"/>
    <sub-header v-if="isAuthenticated" />

    <v-content class="app__container">
      <router-view />
    </v-content>

    <bottom-nav v-if="isAuthenticated" />
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'

import MainHeader from './components/Layout/MainHeader'
import SubHeader from './components/Layout/SubHeader'
import BottomNav from './components/Layout/BottomNav'

export default {
  name: 'App',
  components: {
    MainHeader,
    SubHeader,
    BottomNav
  },
  computed: {
    ...mapGetters(
      'authentication',
      ['isAuthenticated']
    )
  }
}
</script>

<style lang="stylus" src="./assets/styles/main.styl" />
